/* AMR landing — código propio */
document.documentElement.classList.remove('no-js');
(function(){
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return [].slice.call((r||document).querySelectorAll(s))}
  function gallery(){
    $$('[data-amr-gal]').forEach(function(g){
      var tr=$('[data-track]',g), th=$$('.amr-gal__th',g); if(!tr)return;
      function idx(){return Math.round(tr.scrollLeft/tr.clientWidth)}
      function mark(i){th.forEach(function(b,j){b.classList.toggle('on',i===j)})}
      th.forEach(function(b,i){b.addEventListener('click',function(){tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'});mark(i)})});
      var t;tr.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){mark(idx())},80)},{passive:true});
    });
  }
  function carousels(){
    $$('[data-amr-car]').forEach(function(c){
      var tr=$('[data-track]',c); if(!tr)return;
      function step(){var it=tr.children[0];return it?it.getBoundingClientRect().width+parseFloat(getComputedStyle(tr).columnGap||0):tr.clientWidth}
      var p=$('[data-prev]',c),n=$('[data-next]',c);
      if(p)p.addEventListener('click',function(){var l=tr.scrollLeft<=4?tr.scrollWidth:tr.scrollLeft-step();tr.scrollTo({left:l,behavior:'smooth'})});
      if(n)n.addEventListener('click',function(){var end=tr.scrollLeft+tr.clientWidth>=tr.scrollWidth-4;tr.scrollTo({left:end?0:tr.scrollLeft+step(),behavior:'smooth'})});
    });
  }
  function packs(){
    $$('[data-amr-packs]').forEach(function(w){
      var ps=$$('.amr-pack',w);
      ps.forEach(function(p,i){p.addEventListener('click',function(){ps.forEach(function(x){x.classList.toggle('on',x===p);var r=$('input',x);if(r)r.checked=(x===p)});window.AMR_PACK=i+1})});
      if(!$('.amr-pack.on',w)&&ps[0])ps[0].classList.add('on');
    });
  }
  function accordions(){
    $$('[data-amr-acc]').forEach(function(g){
      var ds=$$('details',g);
      ds.forEach(function(d){d.addEventListener('toggle',function(){if(d.open)ds.forEach(function(x){if(x!==d)x.open=false})})});
    });
  }
  function videos(){
    $$('[data-amr-vid]').forEach(function(card){
      var v=$('video',card); if(!v)return;
      card.addEventListener('click',function(){
        $$('[data-amr-vid].playing').forEach(function(o){if(o!==card){o.classList.remove('playing');var ov=$('video',o);if(ov)ov.pause()}});
        if(!v.getAttribute('src')&&v.dataset.src)v.setAttribute('src',v.dataset.src);
        if(v.paused){card.classList.add('playing');v.muted=false;var pr=v.play();if(pr&&pr.catch)pr.catch(function(){v.muted=true;v.play()})}
        else{v.pause();card.classList.remove('playing')}
      });
    });
  }
  function sticky(){
    var s=$('[data-amr-sticky]'),atc=$('.amr-pd .amr-atc');if(!s||!atc)return;
    function on(){var r=atc.getBoundingClientRect();var want=r.bottom<0;if(s.classList.contains('show')!==want)s.classList.toggle('show',want)}
    window.addEventListener('scroll',on,{passive:true});on();
  }
  function menu(){
    var d=$('[data-amr-menu]');if(!d)return;
    $$('[data-amr-menu-open]').forEach(function(b){b.addEventListener('click',function(){d.hidden=false;document.body.style.overflow='hidden'})});
    $$('[data-amr-menu-close]',d).forEach(function(b){b.addEventListener('click',function(){d.hidden=true;document.body.style.overflow=''})});
  }
  function shipDate(){
    $$('[data-amr-ship]').forEach(function(el){
      var d=new Date();d.setDate(d.getDate()+(parseInt(el.getAttribute('data-days'),10)||1));
      var m=['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
      el.textContent=d.getDate()+' de '+m[d.getMonth()];
    });
  }
  /* Botones de compra -> formulario de Releasit (botón oculto). Si Releasit no carga, sigue al checkout. */
  function openRsi(e){var h=document.getElementById('amrRsiHost');var b=h?h.querySelector('button, #rsi_buy_now_button, ._rsi-buy-now-button'):null;if(!b)return false;if(e){e.preventDefault();e.stopPropagation()}b.click();return true}
  document.addEventListener('click',function(e){var a=e.target&&e.target.closest?e.target.closest('[data-amr-buy]'):null;if(!a)return;openRsi(e)},true);
  function init(){gallery();carousels();packs();accordions();videos();sticky();menu();shipDate()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
